import { PropsWithChildren } from 'react';

import cx from 'classnames';
import type { ControlProps, GroupBase } from 'react-select-5';

import s from './index.module.css';

export function Label<
  Option = unknown,
  IsMulti extends boolean = boolean,
  Group extends GroupBase<Option> = GroupBase<Option>,
>({ children, isFocused, hasValue }: PropsWithChildren<ControlProps<Option, IsMulti, Group>>) {
  return (
    <div className={cx(s.labelWrapper, { [s.moveUp]: isFocused || hasValue })}>
      <div className={cx(s.label)}>{children}</div>
    </div>
  );
}
